import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, FlaskConical, Building2 } from "lucide-react";
import useAuth from "../../hooks/useAuth";
import { authApi } from "../../lib/auth";
import { errorMessage } from "../../lib/api";
import ComplianceDashboard from "../../components/compliance/ComplianceDashboard";

export default function ComplianceTenantPage() {
  const { id } = useParams();
  const { isAdmin } = useAuth();
  const [tenant, setTenant] = useState(null);
  useEffect(() => {
    authApi.tenants.get(id).then(setTenant).catch((err) => toast.error("Tenant not found", { description: errorMessage(err) }));
  }, [id]);
  return (
    <div className="ws-page" data-testid="compliance-tenant-page">
      <Link to="/app/compliance" className="ws-back" data-testid="back-to-compliance">
        <ArrowLeft size={14} /> All tenants
      </Link>
      <header className="ws-head">
        <div>
          <h1 data-testid="compliance-tenant-title">
            {tenant?.sample && <FlaskConical size={18} className="sample-ico" />}
            {tenant?.name || "..."}
          </h1>
          <p>
            {tenant?.org_display_name ? `${tenant.org_display_name} · ${tenant.default_domain}` : tenant?.sample ? "Sample data - no Microsoft connection" : tenant?.tenant_id}
            {tenant && (
              <Link to={`/app/tenants/${tenant.id}`} className="tb-btn sm ghost" style={{ marginLeft: 10 }} data-testid="compliance-open-tenant">
                <Building2 size={12} /> Tenant details
              </Link>
            )}
          </p>
        </div>
      </header>
      {tenant && <ComplianceDashboard tenant={tenant} isAdmin={isAdmin} />}
    </div>
  );
}
